import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Technology */}
          <div className="footer-section">
            <h4>Technology</h4>
            <ul className="footer-links">
              <li><Link to="/technology">How It Works</Link></li>
              <li><Link to="/evidence">Evidence &amp; Benchmarks</Link></li>
              {/* Single entry for the merged Docs + Publications page — mirrors the navbar */}
              <li><Link to="/publications">Docs &amp; Research</Link></li>
              <li><Link to="/trust">Trust &amp; Security</Link></li>
              <li><Link to="/scenarios">Scenarios</Link></li>
              <li><Link to="/applications">Applications</Link></li>
            </ul>
          </div>

          {/* Solutions */}
          <div className="footer-section">
            <h4>Solutions</h4>
            <ul className="footer-links">
              <li><Link to="/products">Products</Link></li>
              <li><Link to="/nanolm">NanoLM</Link></li>
              <li><Link to="/memory">Visual Memory</Link></li>
              <li><Link to="/products">AI-PMS</Link></li>
              <li><Link to="/products">SGS.ai</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div className="footer-section">
            <h4>Company</h4>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/partners">Design Partner Program</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4>Contact Us</h4>
            <ul className="footer-contact">
              <li>
                <span className="contact-icon">👤</span>
                Customer Support
              </li>
              <li>
                <span className="contact-icon">📞</span>
                <a href="tel:+919845555760">+91 9845555760</a>
              </li>
              <li>
                <span className="contact-icon">📧</span>
                <a href="mailto:support@codenticai.com">support@codenticai.com</a>
              </li>
              <li>
                <span className="contact-icon">🌐</span>
                <a href="http://www.codenticai.com" target="_blank" rel="noopener noreferrer">
                  www.codenticai.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Codentic AI. All rights reserved.</p>
          <nav className="footer-legal" aria-label="Legal">
            <Link to="/privacy">Privacy Policy</Link>
            <span className="footer-legal-sep" aria-hidden="true">·</span>
            <Link to="/terms">Terms of Use</Link>
            <span className="footer-legal-sep" aria-hidden="true">·</span>
            <Link to="/trust">Trust &amp; Security</Link>
          </nav>
          <p className="footer-tagline">
            Emerging World Models — a memory side-car beside any AI model, never a replacement for it.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
